/**
 * @desc 财务模块
 */
import { financeAxios, financeAxiosDirect } from '../httpInstance';
// 单个买方可用保证金金额 冻结保证金金额 总保证金金额
export function singleBuyerMoney(payload) {
    return financeAxios({
        method: 'GET',
        url: 'singleBuyerMoney',
        params: payload,
    });
}
// 单个卖方可用保证金金额 冻结保证金金额 总保证金金额
export function singleSellerMoney(payload) {
    return financeAxios({
        method: 'GET',
        url: 'singleSellerMoney',
        params: payload,
    });
}
// 总共买方可用保证金金额 冻结保证金金额 总保证金金额
export function allBuyerMoney(params) {
    return financeAxios({
        method: 'GET',
        url: 'allBuyerMoney',
        params,
    });
}
// 总共卖方可用保证金金额 冻结保证金金额 总保证金金额
export function allSellerMoney(params) {
    return financeAxios({
        method: 'GET',
        url: 'allSellerMoney',
        params,
    });
}
// 总共买方保证金列表
export function buyerDepositList(payload) {
    return financeAxios({
        method: 'GET',
        url: 'buyerDepositList',
        params: payload,
    });
}
// 总共卖方保证金列表
export function sellerDepositList(payload) {
    return financeAxios({
        method: 'GET',
        url: 'sellerDepositList',
        params: payload,
    });
}
// 结算情况
export function remitDetail(payload) {
    return financeAxios({
        method: 'GET',
        url: 'remitDetail',
        params: payload,
    });
}
// 付款明细
export function payDetail(payload) {
    return financeAxios({
        method: 'GET',
        url: 'payDetail',
        params: payload,
    });
}
// 保证金退款查看
export function depositDetail(payload) {
    return financeAxios({
        method: 'GET',
        url: 'deposit',
        params: payload,
    });
}
// 总共买方保证金明细列表
export function buyerDepositDetailList(payload) {
    return financeAxios({
        method: 'GET',
        url: 'buyerDepositDetailList',
        params: payload,
    });
}
// 总共卖方保证金明细列表
export function sellerDepositDetailList(payload) {
    return financeAxios({
        method: 'POST',
        url: 'sellerDepositDetailList',
        params: payload,
    });
}
// 买家保证金充值
export function buyerCharge(payload) {
    return financeAxios({
        method: 'POST',
        url: 'buyerCharge',
        params: payload,
    });
}
// 买家保证金退款
export function buyerRefund(payload) {
    return financeAxios({
        method: 'POST',
        url: 'buyerRefund',
        params: payload,
    });
}
// 卖家保证金充值
export function sellerCharge(payload) {
    return financeAxios({
        method: 'POST',
        url: 'sellerCharge',
        params: payload,
    });
}
// 卖家保证金退款
export function sellerRefund(payload) {
    return financeAxios({
        method: 'POST',
        url: 'sellerRefund',
        params: payload,
    });
}
// 提现管理通过并退款
export function applyRefund(payload) {
    return financeAxios({
        method: 'POST',
        url: 'applyRefund',
        data: payload,
    });
}
/**
 * 财务管理---提现管理 */
// 用户保证金提现列表查询
export function depositWithdrawList(payload) {
    return financeAxios({
        method: 'GET',
        url: 'depositWithdrawList',
        params: payload,
    });
}
// 驳回保证金的提现申请
export function rejectDepositWithdraw(payload) {
    return financeAxios({
        method: 'POST',
        url: 'rejectDepositWithdraw',
        params: payload,
    });
}
// 通过保证金的提现申请
export function acceptDepositWithdraw(payload) {
    return financeAxios({
        method: 'POST',
        url: 'acceptDepositWithdraw',
        params: payload,
    });
}
// 导出
export const globalExport = (params) => {
    return financeAxiosDirect({
        url: 'financeExport',
        method: 'POST',
        responseType: 'blob',
        data: params,
    });
};
// 集团账户统计列表
export function selectAccountSumList() {
    return financeAxios({
        method: 'POST',
        url: 'selectAccountSumList',
    });
}
// 集团账户统计详情
export function selectAccountDetailList(payload) {
    return financeAxios({
        method: 'POST',
        url: 'selectAccountDetailList',
        params: payload,
    });
}
// 集团保证金统计列表
export function selectMarginSumList(payload) {
    return financeAxios({
        method: 'POST',
        url: 'selectMarginSumList',
        params: payload,
    });
}
// 作废收款
export function cancelBuyerPay(payload) {
    return financeAxios({
        method: 'POST',
        url: 'cancelBuyerPay',
        data: payload,
    });
}
// 确认买家付款
export function confirmBuyerPay(payload) {
    return financeAxios({
        method: 'POST',
        url: 'confirmBuyerPay',
        data: payload,
    });
}
